const telmaticsConfig = {
  chart: {
    polar: true,
    type: "area",
    animation: {
      duration: 1000
    }
  },

  title: {
    text: "Title",
    x: -80
  },
  colors: ["#B9B309"],
  pane: {
    size: "80%"
  },

  yAxis: {
    gridLineInterpolation: "polygon",
    lineWidth: 0,
    min: 0
  },
  credits: {
    enabled: false
  },

  tooltip: {
    shared: true,
    pointFormat: '<span style="color:{series.color}"> <b>{point.y:,.0f}</b><br/>'
  },
  exporting: { enabled: false },

  legend: {
    enabled: false
  }
};

export default telmaticsConfig;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartTelematicsConfig.js